import React, { useState,useEffect } from 'react'
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import DataTable from 'react-data-table-component';

const DailySummery = () => { 
const[summerydata,setSummeryData]=useState([])
 const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
  const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);

    

const fetchSummeryData=async()=>{
  const post={SendDateTimeFrom:startTime,SendDateTimeTo:endTime}
  try {
     const res=await AddUpdate ("NotificationTracking/GetData_DailyBusinessSummary",post)
    
   
      const data=JSON.parse(res?.data?.data)
      const finaldata=data?.Table
      
      setSummeryData(finaldata)
     

  } catch (error) {
     console.log("error",error)
  }
}

  const columns = [
 
    {
      name: "Id",
      selector: (row) => row.Id,
      sortable: true,
      width:"100px"
    },
    
    {
      name: "TotalAmtInvard",
      selector: (row) => row.TotalAmountInvard,
      sortable: true,
         width:"200px"
      
    },
   {
      name: "TotalSellPackage",
      selector: (row) => row.TotalSellingPackage,
      sortable: true,
      width:"200px"
    },
   
    {
      name: "TopPackageCount",
      selector: (row) => row.TopPackageCount,
      sortable: true,
         width:"200px"
    },

    {
      name: "NewRegisteredUsers",
      selector: (row) => row.NewRegisteredUsers,
      sortable: true,
         width:"200px"
      
    },
   
    {
      name: "NewUsers",
      selector: (row) => row.NewUsers,
      sortable: true,
         width:"200px"
    },
     {
      name: "RepeatedUsers",
      selector: (row) => row.RepeatedUsers,
      sortable: true,
         width:"200px"
    },



    {
      name: "TotalChats",
      selector: (row) => row.TotalChats,
      sortable: true,
         width:"200px"
      
    },
   {
      name: "TotalAmountChats",
      selector: (row) => row.TotalAmountChats,
      sortable: true,
         width:"200px"
      
    },
   
    {
      name: "TotalCalls",
      selector: (row) => row.TotalCalls,
      sortable: true,
         width:"200px"
    },

     {
      name: "TotalAmountCalls",
      selector: (row) => row.TotalAmountCalls,
      sortable: true,
         width:"200px"
       
    },
    
    {
      name: "TotalGemstoneCount",
      selector: (row) => row.TotalGemstoneCount,
      sortable: true,
         width:"200px"
      
    },
   
    {
      name: "TotalAmountGemstone",
      selector: (row) => row.TotalAmountGemstone,
      sortable: true,
    },
     {
      name: "TotalPuja",
      selector: (row) => row.TotalPuja,
      sortable: true,
         width:"200px"
    },
     {
      name: "TotalAmountPuja",
      selector: (row) => row.TotalAmountPuja,
      sortable: true,
         width:"200px"
      
    },
   
    {
      name: "TopAstrologers",
      selector: (row) => row.TopAstrologers,
      sortable: true,
         width:"200px"
    },
     {
      name: "PeakHours",
      selector: (row) => row.PeakHours,
      sortable: true,
         width:"200px"
    }
   
  
  ];

 useEffect(()=>{
    fetchSummeryData()
  },[])






const handleSearch = () => {
    if (startTime ) {
      const formatDate = (dateTime) => {
        if (!dateTime) return null;
        const date = new Date(dateTime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = formatDate(startTime);
      const formattedEndDate = formatDate(endTime);

      const data = {
        FromDate: formattedStartDate,
        Todate: formattedEndDate,
      };

       
        fetchSummeryData()
    }
  };
  return (
   <>

  <div className="form-group  main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Daily Summary</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
           
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
        </div>
            <div className="col-3 mt-3">
        <button className="btn btn-primary " onClick={handleSearch}>
              Search
            </button>
            </div>
        
        </div>
       
       
      </div>

 <div className="col-12 mt-2  main_card">
        
          <DataTable
            dense
            data={summerydata || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            customStyles={customStyles}
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
       
      </div>

   </>
  )
}


export default DailySummery